import template from './index.pug'
import Vue from 'vue'

Vue.component('cookies', {
  name: 'cookies',
  template: template(),

  data() {
    return {
      acceptedCookies: undefined
    }
  },

  created() {
    this.acceptedCookies = this.$cookies.get('acceptedCookies')
  },

  methods: {
    acceptCookies() {
      this.$cookies.set('acceptedCookies', 'true', Infinity)
      this.acceptedCookies = 'true'
    },

    goToPrivacyPolicy() {
      if (this.$currentAppConfig.code === 'gc') {
        const routeData = 'https://autgc.org/cookie-policy-eu/'
        window.open(routeData)
      } else {
        this.$router.push({name: 'privacy-policy'})
      }
      this.$el.querySelector('.ns-button--secondary').blur()
    }
  }
})
